<template>
  <div class="item-view d-flex flex-row-auto">
    <div v-for="(col, i) of items" :key="i" :class="'col-' + 12 / items.length"
      class="d-flex flex-column align-items-start min-w-200px">
      <div v-for="(value, key, i) of col" :key="i" class="d-flex justify-between align-start min-h45">
        <span class="min-w-100px" v-text="$t(key)" />
        <slot v-if="value && value.slot" :name="value.slot" />
        <span v-else class="gray-txt single-rp" v-html="value" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: { items: { default: () => [] } },
}
</script>